export const getCurrentPageRoutePart = () => {
    const pathname = window.location.pathname;
    const routeParts = pathname.split('/');
    return routeParts[routeParts.length - 1];
}

export const isRestrictedDomain = (email) => {
    const restrictedDomains = ['gmail.com', 'hotmail.com', 'yahoo.com'];
    const message = `Please use the work email to sign up.`;
    if (!email) return {status: false, message: `Please provide an email.`};
    const matchedDomain = restrictedDomains.filter(domainName => {
        return email.trim().toLowerCase().includes(domainName.trim().toLowerCase());
    })
    if (matchedDomain.length > 0) return {status: true, message};
    return {status: false, message: `${matchedDomain[0]} is allowed.`};
}

export const getPastDateByYears = (years = 0) => {
    const myDate = new Date();
    const pastDate = new Date((new Date()).setFullYear(myDate.getFullYear() - years));
    // console.info({pastDate});
    return pastDate;
}
